import { MCImplementation } from '@adsk/bim360-mc-implementation';

class DocsSDKWrapper {
  constructor(config, tokenConfig) {
    this.DocsSDK = new MCImplementation({ ...config, withCredentials: false, token: tokenConfig.token, expireTime: tokenConfig.expirationTime });
  }

  refreshCookie() {
    return this.DocsSDK.refreshCookie();
  }

  getProjectById(projectId) {
    return this.DocsSDK.getProjectById(projectId);
  }

  getDocumentsByURNs(projectId, urns) {
    return this.DocsSDK.getDocumentsByURNs(projectId, urns);
  }

  getFoldersListByProjectId(projectId) {
    return this.DocsSDK.getFoldersListByProjectId(projectId);
  }

  getFolderContents(projectId, urn, options) {
    return this.DocsSDK.getFolderContents(projectId, urn, options);
  }

  getUsersInProject(projectId) {
    return this.DocsSDK.getUsersInProject(projectId);
  }

  getCompeniesInProject(projectId) {
    return this.DocsSDK.getCompaniesInProject(projectId);
  }

  getRolesInProject(projectId) {
    return this.DocsSDK.getRolesInProject(projectId);
  }
}

export default (() => {
  const instance = {};

  return (config, tokenConfig) => {
    if (config) {
      instance.docsSDK = new DocsSDKWrapper(config, tokenConfig);
    }

    return instance;
  };
})();
